import Vue from "vue";

export default {
	state: {
		actualCompanyGroup: {},
		companyGroups: []
	},
	mutations: {
		setCompanyGroupOnState(state, actualCompanyGroup) {
			state.actualCompanyGroup = mapCompanyGroup(actualCompanyGroup);
		},
		setCompanyGroupsOnState(state, companyGroups) {
			state.companyGroups = companyGroups;
		}
	},
	actions: {
		getCompanyGroups({ commit }) {
			return new Promise((resolve) => {
				Vue.prototype.$http
					.get("companyGroup")
					.then((response) => {
						this.state.loading = false;
						commit("setCompanyGroupsOnState", response.data.data);
						resolve(response);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		getCompanyGroup({ commit }, id) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("CompanyGroup/" + id)
					.then((response) => {
						commit("setCompanyGroupOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		createCompanyGroup(_, companyGroup) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("CompanyGroup", companyGroup)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error.response.data.error.message);
					});
			});
		},
		editCompanyGroup(_, companyGroup) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				mapCompanyGroupToBack(companyGroup).then((mappedCompanyGroup) => {
					Vue.prototype.$http
						.put("companyGroup/" + mappedCompanyGroup.IdCompanyGroup, mappedCompanyGroup)
						.then((response) => {
							this.state.loading = false;
							resolve(response);
						})
						.catch((error) => {
							this.state.loading = false;
							reject(error.response.data.error.message);
						});
				});
			});
		},
		deleteCompanyGroup(_, id) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.delete("CompanyGroup/" + id)
					.then((response) => {
						this.state.loading = false;
						resolve(response);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		}
	},
	getters: {
		companyGroup({ actualCompanyGroup }) {
			return actualCompanyGroup;
		},
		companyGroups({ companyGroups }) {
			return companyGroups;
		}
	}
};

const mapCompanyGroup = (companyGroupFromBack) => {
	let response = {
		idCompanyGroup: companyGroupFromBack.idCompanyGroup,
		description: companyGroupFromBack.description,
		activated: companyGroupFromBack.activated,
		initialHour: companyGroupFromBack.initialHour,
		finalHour: companyGroupFromBack.finalHour,
		hours: companyGroupFromBack.hours
	};
	return response;
};

const mapCompanyGroupToBack = (companiesGroup) => {
	return new Promise((resolve) => {
		let retObject = {
			IdCompanyGroup: companiesGroup.idCompanyGroup,
			Description: companiesGroup.description,
			Activated: companiesGroup.activated,
			CodeERP: companiesGroup.codeERP,
			InitialHour: companiesGroup.initialHour,
			Finalhour: companiesGroup.finalHour,
			Hours: companiesGroup.hours
		};
		resolve(retObject);
	});
};
